<div class="mt-input">
    <label *ngIf="label" class="mt-label">
        <img *ngIf="tooltipDescription?.length" appImageSelector imageType="icon" imageKey="info" placement="right"
            [ngbTooltip]="tooltipDescription" class="tooltip-info" />
        {{ label }} <span class="required-symbol" *ngIf="requiredField">*</span>
    </label>
    <div class="input-group">
        <textarea #mtInput #textarea class="custom-textearea form-control" rows="{{ rows }}"
            placeholder="{{ placeholder }}" [maxLength]="maxCharLength" 
            (input)="onInput($event.target)" [(ngModel)]="value" (blur)="onTouched()" (keypress)="onKeyPress($event)" (change)="onChange($event.target.value)"></textarea>
        <img *ngIf="clearable && mtInput.value.length" appImageSelector imageType="icon" imageKey="x-input-icon"
            class="normalIconPosition pointer" (click)="clearInput()">
    
        <span class="error-message" *ngIf="errorMessage">
            <img alt="mt-image" appImageSelector imageType="icon" imageKey="alert-input">
            <p class="error-message-text" [innerHTML]="errorMessage"></p>
        </span>
        <span class="input-counter" *ngIf="maxCharLength" [ngClass]="{'input-counter-error': errorMessage}">
            {{ max((maxCharLength) - (mtInput.value.length), 0) }}
        </span>
    </div>
</div>